import router from '../router'

export default {
  namespaced: true,

  state: () => ({
    id: null,
    name: null,
    email: null,
    token: null,
  }),

  getters: {
    user: (state) => state,
  },

  mutations: {
    setUserData (state, payload) {
      state.id = payload.id
      state.name = payload.name
      state.email = payload.email
      state.token = payload.token
    },
    unsetUserData (state) {
      state.id = null
      state.name = null
      state.email = null
      state.token = null
    },
  },

  actions: {
    async register ({ commit }, payload) {
      const res = await window.axios.post('user', payload)
      commit('setUserData', res.data)
      router.push('/login')
    },
    async login ({ commit }, payload) {
      const res = await window.axios.post('user/login', payload)
      commit('setUserData', res.data)
      window.axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`
      router.push('/')
    },
  },
}
